namespace Areas.Dialogs.SelectTemplate {
    "use strict";



    let dailyReportTemplateId: number;

    export class SelectTemplateDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("SelectTemplate", closeHandler, parameters, () => {

                const dataGrid = $(`#${this.dialogName}Grid`).dxDataGrid('instance');
                const selectedRows: any = dataGrid.getSelectedRowsData();

                if (selectedRows[0] != null) {
                    const form = $("#SelectTemplateForm").dxForm("instance");
                    let data = selectedRows[0];
                    form.option("formData", data);
                }


            });
        }

        protected ok = (e: any) => {

            const dataGrid = $(`#${this.dialogName}Grid`).dxDataGrid('instance');
            const selectedRows: any = dataGrid.getSelectedRowsData();

            if (selectedRows[0] == null) {
                DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
            } else {
                var data = selectedRows[0].reportNotesTemplate;
                this.close(DialogResult.Ok, data);
            }

           
            
        }
    }

    export function reportTemplateCellTemplate(cellElement: any, cellInfo: any) {
        cellElement.text(cellInfo.value);

    }  

    export function onTemplateGridSelectionChanged(e: any) {
        const rowData: any = e.selectedRowsData[0];
        dailyReportTemplateId = rowData.dailyReportTemplateId;

        const rowForm: any = $("#SelectTemplateForm").dxForm("instance");
        rowForm.option("formData", rowData);

    }




}
